import auth from "../middleware/auth";

const routes = [
  {
    path: "/partners",
    name: "Partners",
    component: () => import("../../views/protected/PartnersPage"),
    meta: {
      layout: () => import("../../layouts/protected"),
      middleware: [auth],
      title: "Partners",
    },
  },
];

export default routes;
